import { BotAvatar } from './bot-avatar';

import styles from './chat-message.module.css';

export const TypingIndicator = () => (
	<div className={`${styles.message} ${styles.assistantMessage}`}>
		<BotAvatar />
		<div className={styles.messageContent}>
			<div className={styles.typingIndicator}>
				<span></span>
				<span></span>
				<span></span>
			</div>
		</div>
	</div>
);
